export const KEY_COOKIE_WELCOME = 'welcomeWally';
export const KEY_LS_WELCOME_BACK = 'LSwelcomeWally';
